(function($) {
  $(document).ready(function() {
    var productType = '';

    //window.loggedIn

    function updatePickupBlock() {

      $.getJSON('/cart.js', function(cart) {
        var hasCatering = cart.items.some(function(item) {
          productType = "Catering";
          return item.product_type === "Catering";
        });
        var hasWholesale = cart.items.some(function(item) {
          productType = "Wholesale";
          return item.product_type === "Wholesale";
        });

        if (!window.loggedIn && hasWholesale) {
            $.ajax({
              type: 'POST',
              url: '/cart/clear.js',
              success: function() {
                window.location.reload(true);
              }
            });
        }

        if (!hasCatering && cart.attributes && cart.attributes.schedule) {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            data: { attributes: { schedule: '' } }
          });
        }

        if (hasCatering) {
          if (!$('#pickup-datetime-block').length) createPickupBlock(cart);
          if (!$('#minimum-order-note').length) insertMinimumNotice();
        }else if (hasWholesale) { 
          if (!$('#minimum-order-note').length) insertMinimumNotice();
        } else {
          $('#pickup-datetime-block').remove();
          $('#minimum-order-note').remove();
        }
      });
    }
    // Insert minimum order note if not already added
    function insertMinimumNotice() {
        if (!$('#minimum-order-note').length) {
            $('#slidecarthq .footer').before(
            '<div id="minimum-order-note" style="padding: 10px; font-size: 14px; background: #fff3cd; color: #664d03; border: 1px solid #ffeeba; border-radius: 6px; margin-bottom: 10px;">' +
            '⚠ For '+ productType +' a minimum of $50 is required to proceed to checkout.' +
            '</div>'
            );
        }
    }
    function createPickupBlock(cart) {
      var $block = $('<div>', { class: 'footer-row-date-time', id: 'pickup-datetime-block' });

      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      var yyyy = tomorrow.getFullYear();
      var mm = ("0" + (tomorrow.getMonth() + 1)).slice(-2);
      var dd = ("0" + tomorrow.getDate()).slice(-2);
      var minDate = yyyy + '-' + mm + '-' + dd;

      var $header = $('<div>', { class: 'pickup-header', text: 'Select Pickup date and time' });

      var $row = $('<div>', { class: 'pickup-row', style: 'display: flex; gap: 10px; align-items: center; margin-top: 5px;' });
      var $dateInput = $('<input>', { type: 'date', id: 'pickup-date', name: 'pickup-date', min: minDate, value: minDate, style: 'flex: 1;' });
      var $timeSelect = $('<select>', { id: 'pickup-time', name: 'pickup-time', style: 'flex: 1;' });

      for (var h = 5; h <= 23; h++) {
        var hour = h;
        var ampm = hour < 12 ? 'AM' : 'PM';
        var displayHour = hour % 12 === 0 ? 12 : hour % 12;
        var optionText = displayHour + ':00 ' + ampm;
        var optionValue = (hour < 10 ? '0' + hour : hour) + ':00';
        $timeSelect.append($('<option>', { value: optionValue, text: optionText }));
      }

      $row.append($dateInput, $timeSelect);

      var $buttonWrapper = $('<div>', { style: 'width:100%; position: relative; display: inline-block; margin-top: 5px;' });
      var $button = $('<button>', { type: 'button', id: 'pickup-save-btn', text: 'SET', style: 'padding: 5px 10px; cursor: pointer;' });
      var $tooltip = $('<div>', { id: 'pickup-tooltip', text: '', style: 'position: absolute;top: -150px;left: 50%;transform: translateX(-50%);background: rgb(76, 175, 80);color: white;padding: 7px 10px;border-radius: 3px;font-size: 16px; display: none; width: max-content;' });
      $buttonWrapper.append($button, $tooltip);

      $block.append($header, $row, $buttonWrapper);
      $('#slidecarthq .footer').prepend($block);

      if (cart.attributes && cart.attributes.schedule) {
        $button.text('UPDATE');
        var match = cart.attributes.schedule.match(/(\d{4}-\d{2}-\d{2}) at (\d{2}:\d{2})/);
        if (match) {
          $dateInput.val(match[1]);
          $timeSelect.val(match[2]);
        }
      }

      $button.on('click', function() {
        var selectedDate = $dateInput.val();
        var selectedTime = $timeSelect.val();
        if (!selectedDate || !selectedTime) return;

        var attributeValue = `To be picked up on ${selectedDate} at ${selectedTime}`;

        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          data: { attributes: { schedule: attributeValue } },
          success: function() {
            $button.text('UPDATE');
            $tooltip.stop(true, true).text('Pickup schedule saved!').fadeIn(200).delay(1500).fadeOut(400);
          },
          error: function() {
            $tooltip.stop(true, true).text('Failed to save.').fadeIn(200).delay(1500).fadeOut(400);
          }
        });
      });
    }

    function controlCheckoutButton() {
        $.getJSON('/cart.js', function(cart) {

            // // Sum only Catering product prices

            // var productTotal = cart.items
            //     .filter(item => item.product_type === productType)
            //     .reduce((sum, item) => sum + item.price * item.quantity, 0);


            // var totalAmount = productTotal / 100; // Convert cents to dollars
            // var minAmount = 50; // Minimum $50 Amount


            // var $checkoutBtn = $('#slidecarthq .footer .button'); 
            // if (!$checkoutBtn.length) return;

            // if (cart.items.length === 0 || totalAmount < minAmount) {
            //     $checkoutBtn.prop('disabled', true)
            //                 .css({ opacity: '0.5', pointerEvents: 'none' });
            // } else {
            //     $checkoutBtn.prop('disabled', false)
            //                 .css({ opacity: '1', pointerEvents: 'auto' });
            // }
        });
    }


    var target = document.querySelector('.slidecarthq-overlay');
    if (target) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === "class" && $(target).hasClass("open")) {
            updatePickupBlock();
            controlCheckoutButton();
          }
        });
      });
      observer.observe(target, { attributes: true });
    }

    updatePickupBlock();

    var fallbackInterval = setInterval(function() {
        updatePickupBlock();
        controlCheckoutButton();
    }, 1000);

  });
})(jQuery);
